import React, {useCallback} from "react";
import classNames from "classnames";
import {isMobileOnly} from "react-device-detect";
import ReactGA from 'react-ga';

import {textMap, imageMap} from "../common/Localization";

import './TopIntro.scss';

const TopIntro = () => {
	const sendGa = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"첫페이지-미니맵에광고하기"
		});
	}, []);

	return (
		<div id="topIntro" className="bc_ff view_section">
			<div className="top_intro_wrap">
				<div className="text_wrap">					
					<div className={classNames("intro_text", "c_28")}>
						{
							isMobileOnly ? 
							textMap.formatString(textMap.top_intro_text_mobile, <span className={classNames("price_tag", "c_blue", "cbc_light_blue")}>{textMap.top_intro_price}</span>) :
							textMap.formatString(textMap.top_intro_text, <span className={classNames("price_tag", "c_blue", "cbc_light_blue")}>{textMap.top_intro_price}</span>)
						}
					</div>
					<div className="button_wrap">
						<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa}>
							<span className={classNames("go_button", "cbc_blue", "sc_blue", "c_ff")}>{textMap.top_intro_button}</span>
						</a>
					</div>
				</div>
				<div className="image_wrap">
					<img className="mockup" src={process.env.PUBLIC_URL + "/img/" + imageMap.top_intro} alt=""/>
					<span className={classNames("comment", "comment_1", "cbc_red", "c_ff", "sc_red")}>
						<img className={classNames("profile_image", "sc_gray")} src={process.env.PUBLIC_URL + "/icon/profile_red.png"} alt=""/>
						<span>{textMap.top_intro_comment_1}</span>
						<span className={classNames("triangle", "lc_red")}></span>
					</span>
					<span className={classNames("comment", "comment_2", "cbc_green", "c_ff", "sc_green")}>
						<img className={classNames("profile_image", "sc_gray")} src={process.env.PUBLIC_URL + "/icon/profile_green.png"} alt=""/>
						<span>{textMap.top_intro_comment_2}</span>
						<span className={classNames("triangle", "lc_green")}></span>
					</span>
					<span className={classNames("comment", "comment_3", "cbc_blue", "c_ff", "sc_blue_2")}>
						<img className={classNames("profile_image", "sc_gray")} src={process.env.PUBLIC_URL + "/icon/profile_blue.png"} alt=""/>
						<span>{textMap.top_intro_comment_3}</span>
						<span className={classNames("triangle", "lc_blue")}></span>
					</span>
				</div>
			</div>
			<div className={classNames("top_intro_footer", "bc_light_blue")}>
				<div className={classNames("arc", "bc_ff")}></div>
			</div>
		</div>
	);
};

export default TopIntro;
